import * as React from "react";
const SvgConvertCardActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#convertCardActive_svg__a)">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.387}
        d="M21.248 14.775a6.47 6.47 0 0 1-6.475 6.475l.972-1.619M2.75 9.225A6.47 6.47 0 0 1 9.225 2.75l-.971 1.619"
      />
      <path
        fill="#fff"
        d="M21.25 4.785v.102a.46.46 0 0 1-.462.462h-8.325A.46.46 0 0 1 12 4.887v-.102c0-1.628.407-2.035 2.053-2.035h5.143c1.647 0 2.054.407 2.054 2.035M12.463 6.273a.46.46 0 0 0-.463.462v1.8410000000000002c0 1.628.407 2.035 2.053 2.035h5.143c1.647 0 2.054-.407 2.054-2.035V6.735a.46.46 0 0 0-.462-.462zM12 15.423v.101a.46.46 0 0 1-.463.463H3.214a.46.46 0 0 1-.463-.463v-.101c0-1.629.407-2.036 2.053-2.036h5.144c1.646 0 2.053.407 2.053 2.035M3.213 16.91a.46.46 0 0 0-.463.463v1.8410000000000002c0 1.628.407 2.035 2.053 2.035h5.144c1.646 0 2.053-.407 2.053-2.035v-1.8410000000000002a.46.46 0 0 0-.463-.463z"
      />
    </g>
    <defs>
      <clipPath id="convertCardActive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgConvertCardActive;
